export const billTypeHeaderSelectWrapStyle = {
  display: "inline-block",
  minWidth: "96px",
  width: "max-content",
  maxWidth: "240px",
};

export const billTypeHeaderSelectStyles = {
  control: (base) => ({
    ...base,
    minHeight: "34px",
    height: "34px",
    minWidth: "96px",
    width: "max-content",
    border: "1px solid #ced4da",
    borderRadius: "12px",
    boxShadow: "none",
    backgroundColor: "#fff",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 12px",
    height: "34px",
    flexWrap: "nowrap",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  singleValue: (base) => ({
    ...base,
    margin: 0,
    color: "#495057",
    fontSize: "0.85rem",
    whiteSpace: "nowrap",
    position: "static",
    transform: "none",
    maxWidth: "none",
  }),
  indicatorsContainer: () => ({
    display: "none",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    width: "max-content",
    minWidth: "100%",
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "0.85rem",
    whiteSpace: "nowrap",
    backgroundColor: state.isFocused ? "#f8f9fa" : "white",
    color: "#000",
  }),
};

export const createdByHeaderSelectWrapStyle = {
  display: "inline-block",
  minWidth: "160px",
  width: "180px",
  maxWidth: "240px",
};

export const createdByHeaderSelectStyles = {
  control: (base) => ({
    ...base,
    minHeight: "34px",
    minWidth: "160px",
    border: "1px solid #ced4da",
    borderRadius: "12px",
    boxShadow: "none",
    backgroundColor: "#fff",
    cursor: "text",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "2px 8px",
    flexWrap: "nowrap",
    overflow: "hidden",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    opacity: 1,
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: "0.85rem",
    color: "#6c757d",
    whiteSpace: "nowrap",
  }),
  singleValue: (base) => ({
    ...base,
    margin: 0,
    color: "#495057",
    fontSize: "0.85rem",
    whiteSpace: "nowrap",
    maxWidth: "calc(100% - 8px)",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "0 6px",
    color: "#6c757d",
    cursor: "pointer",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "0 4px",
    cursor: "pointer",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    minWidth: "100%",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "0.85rem",
    whiteSpace: "nowrap",
    backgroundColor: state.isFocused ? "#f8f9fa" : "white",
    color: "#000",
  }),
};
